// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAzY8O-FT7OoVTG2bzMbLgT-CF_-XXVONc",
  authDomain: "photology-2dab9.firebaseapp.com",
  projectId: "photology-2dab9",
  storageBucket: "photology-2dab9.appspot.com",
  messagingSenderId: "35436044454",
  appId: "Photology-2dab9",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();